/* Recover only marketing-popup locks after their popup has disappeared. */
(() => {
  const body = document.body;
  const html = document.documentElement;
  const psClass = 'ps-scroll-lock';
  const klClass = 'klaviyo-prevent-body-scrolling';
  const properties = ['position', 'top', 'left', 'right'];
  const values = (style, names) => names.map(name => [name, style.getPropertyValue(name), style.getPropertyPriority(name)]);
  const snapshot = () => ({body: values(body.style, properties), html: values(html.style, ['min-height'])});
  const psLocked = () => body.classList.contains(psClass) || html.classList.contains(psClass);
  const klLocked = () => body.classList.contains(klClass) || html.classList.contains(klClass);
  let before = psLocked() ? null : snapshot();
  let psSession = psLocked();
  let timer;
  const visible = node => {
    if (!node || !node.getClientRects().length) return false;
    const style = getComputedStyle(node);
    // Klaviyo can leave its fullscreen container mounted after fade-out ends.
    if (style.animationName.includes('klaviyo-fadeout') && Number(style.opacity) === 0) return false;
    return style.display !== 'none' && style.visibility !== 'hidden' && node.getAttribute('aria-hidden') !== 'true';
  };
  const activeDialog = () => [...document.querySelectorAll('[role="dialog"][aria-modal="true"], dialog[open], .new-main-product-popup.active')].some(visible)
    || html.classList.contains('js-drawer-open') || body.classList.contains('js-drawer-open');
  const psOpen = () => {
    const frame = document.getElementById('ps__widget');
    // Postscript collapses its iframe to a 90px teaser after dismissal.
    return visible(frame) && frame.getBoundingClientRect().height > 120;
  };
  const restore = (style, saved) => saved.forEach(([name, value, priority]) => {
    if (value) style.setProperty(name, value, priority);
    else style.removeProperty(name);
  });
  const recover = () => {
    timer = undefined;
    const klOpen = [...document.querySelectorAll('[data-kl-scroll-locking-modal], [role="dialog"][class*="kl-private-"]')].some(visible);
    if (klLocked() && !klOpen) {
      body.classList.remove(klClass);
      html.classList.remove(klClass);
    }
    if ((psSession || psLocked()) && !psOpen() && !activeDialog()) {
      const top = body.style.getPropertyValue('top');
      const fixedByPopup = body.style.getPropertyValue('position') === 'fixed'
        && /^-?\d+(\.\d+)?px$/.test(top)
        && body.style.getPropertyValue('left') === '0px'
        && body.style.getPropertyValue('right') === '0px';
      const scrollPosition = fixedByPopup ? Math.max(0, -parseFloat(top)) : null;
      body.classList.remove(psClass);
      html.classList.remove(psClass);
      if (fixedByPopup) {
        restore(body.style, before?.body || properties.map(name => [name, '', '']));
      }
      if (html.style.getPropertyPriority('min-height') === 'important' && /^\d+(\.\d+)?px$/.test(html.style.minHeight)) {
        restore(html.style, before?.html || [['min-height', '', '']]);
      }
      psSession = false;
      before = snapshot();
      if (scrollPosition !== null) window.scrollTo({top: scrollPosition, behavior: 'instant'});
    }
  };
  const schedule = () => {
    if (timer === undefined) timer = window.setTimeout(recover, 500);
  };
  new MutationObserver(records => {
    if (psLocked() && !psSession) {
      psSession = true;
      // Attribute oldValue preserves the inline styles from before the lock.
      const oldBody = records.find(r => r.target === body && r.attributeName === 'style');
      const oldHtml = records.find(r => r.target === html && r.attributeName === 'style');
      const previous = snapshot();
      for (const [record, key, names] of [[oldBody, 'body', properties], [oldHtml, 'html', ['min-height']]]) {
        if (!record) continue;
        const probe = document.createElement('div');
        probe.style.cssText = record.oldValue || '';
        previous[key] = values(probe.style, names);
      }
      before = previous;
    }
    if (psSession || psLocked() || klLocked()) schedule();
    else before = snapshot();
  }).observe(html, {subtree: true, childList: true, attributes: true, attributeOldValue: true,
    attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']});
  window.addEventListener('klaviyoForms', schedule);
  // Klaviyo leaves a closed popup mounted, invisible, over the page. Mark it from Klaviyo's own close event so
  // CSS can let taps through: Safari rewrites its inline animation styles, so those can't be matched reliably.
  window.addEventListener('klaviyoForms', event => {
    const {type, formId} = event.detail || {};
    if ((type !== 'close' && type !== 'open') || !formId) return;
    document.querySelectorAll('[data-kl-scroll-locking-modal]').forEach(modal => {
      if (modal.querySelector(`[data-testid="klaviyo-form-${formId}"]`)) modal.toggleAttribute('data-ceb-kl-closed', type === 'close');
    });
  });
  document.addEventListener('animationend', event => {
    if (event.animationName?.includes('klaviyo-fadeout')) schedule();
  }, true);
  window.addEventListener('pageshow', schedule);
  window.addEventListener('resize', schedule, {passive: true});
  schedule();
})();
